<template>
    <div class="stepper-container">
        <h3 class="stepper-title">Nuevas rutas</h3>
        <div class="stepper">
            <div 
                v-for="(step, index) in steps" 
                :key="step.number"
                class="step-wrapper"
            >
                <div class="step" :class="getStepClass(step.number)">
                    <div class="step-number">
                        <p class="mb-0">{{ step.number }}</p>
                    </div>
                    <div class="step-title">
                        <p class="mb-0">{{ step.title }}</p>
                    </div>
                </div>
                <div 
                    v-if="index < steps.length - 1" 
                    class="step-divider" 
                    :class="getDividerClass(step.number)"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
const STEPS = [
    { number: 1, title: 'Información de la ruta' },
    { number: 2, title: 'Seleccionar cursos' },
    { number: 3, title: 'Inscribir usuarios' },
    { number: 4, title: 'Ruta creada con éxito' }
];

export default {
    name: 'CreateCustomRouteStepper',
    props: {
        activeStep: { type: Number, required: true, default: 0 }
    },
    data() {
        return {
            steps: STEPS
        };
    },
    methods: {
        getStepClass(stepNumber) {
            if (this.activeStep === stepNumber) return 'active-step';
            if (this.activeStep > stepNumber) return 'done-step';
            return '';
        },
        getDividerClass(stepNumber) {
            if (this.activeStep === stepNumber) return 'active-divider';
            if (this.activeStep > stepNumber) return 'done-divider';
            return '';
        }
    }
};
</script>

<style scoped>
.stepper-container {
    background-color: #cbb9ff66;
    border-radius: 20px;
    padding: 1.5rem;
    height: 100%;
}

.stepper-title {
    color: #1A0054;
    text-align: center;
    font-weight: 700;
    margin: 1rem 0 1.5rem;
}

.stepper {
    display: flex;
    flex-direction: column;
}

.step-wrapper {
    display: flex;
    flex-direction: column;
}

.step {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin: 0 1.875rem;
}

.step-number {
    background-color: #CBB9FF99;
    border-radius: 50%;
    font-weight: bold;
    color: #9164FF;
    font-size: 1.5625rem;
    width: 2.8125rem;
    height: 2.8125rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.step-title {
    color: #6B6876;
    font-size: 1rem;
}

.step-divider {
    width: 0.625rem;
    height: 3.75rem;
    background-color: #CBB9FF99;
    border-radius: 1.25rem;
    margin: 0.3125rem 0 1.25rem 3.75rem;
}

.active-divider {
    background-color: #D537ED;
}

.done-divider {
    background-color: #DA89E8CC;
}

.active-step .step-number {
    background-color: #D537ED;
    color: #1A0054;
}

.done-step .step-number {
    background-color: #DA89E8CC;
    color: #1A0054;
}

.active-step .step-title {
    color: #1A0054;
    font-weight: 600;
}

@media (max-width: 576px) {
    .stepper {
        flex-direction: row;
        justify-content: space-between;
    }

    .step-wrapper {
        flex: 1;
    }

    .step {
        flex-direction: column;
        text-align: center;
        margin: 0;
        gap: 0.5rem;
    }

    .step-title {
        font-size: 0.6875rem;
        max-height: 2.25rem;
        overflow: hidden;
    }

    .step-divider {
        display: none;
    }

    .stepper-title {
        text-align: left;
        margin-left: 1rem;
    }
}
</style>
